<template>
	<div class="huaishuContainer">
		<!-- 导航 -->
		<div class="navBar">
			<img class="navLogo" src="../assets/logo2.png" @click="enterHome" alt="">
			<ul class="navBarItem">
				<!-- <li class="busiz-active-sel"><router-link exact to="/" tag="a">首页</router-link></li> -->
				<li><router-link to="/aboutlanshu" exact tag="a">关于兰树</router-link></li>
				<el-dropdown>
					<li><router-link to="/huaiBrand" exact style="font-size:1em;" tag="a">兰树品牌</router-link></li>
					<el-dropdown-menu class="elDropdown" slot="dropdown">
						<el-dropdown-item><router-link to="/huaiBrand" tag="a">淮树</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/brand" tag="a">心清堂</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/shuiBrand" tag="a">水姻缘</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/yiBrand" tag="a">一清堂</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/zhongBrand" tag="a">Dr.CHUNG<span style="vertical-align: super;">+</span></router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/lanshuBrand" tag="a">兰树</router-link></el-dropdown-item>
						<el-dropdown-item><router-link to="/zbqfBrand" tag="a">植本清方</router-link></el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<li><router-link to="/park" exact tag="a">智慧园区</router-link></li>
				<li><router-link to="/brandLanshu" exact tag="a">美业菩提</router-link></li>
				<li><router-link to="/school" exact tag="a">兰树商学院</router-link></li>

				<li><router-link to="/dynamicLanshu" exact tag="a">菩提基金会</router-link></li>

				<li><router-link to="/lanshuTrends" exact tag="a">兰树动态</router-link></li>
			</ul>
		</div>

		<!-- <div class="productsBd"> -->
		<!-- <el-carousel class="carouselMainBox" :height="bannerHeight+ 'px' " :data-id="item.id" :class="item.id == brandId ? 'block' : 'none'" v-for="(item,index) in brandItem" :key="index" :interval="5000" arrow="always"   autoplay indicator-position="none">
				   <el-carousel-item v-for="(lunimgitem,index) in item.imgBox" :key="index">
				       <img ref="bannerHeight" @load="imgLoad" class="carouselImg" :src="lunimgitem.img" alt="">
				   </el-carousel-item>
				</el-carousel> -->
		<!-- 	</div> -->

		<el-carousel v-if="this.brandId == 1" class="carouselMainBox" :height="bannerHeight + 'px'" :interval="5000"
			arrow="always" autoplay indicator-position="none">
			<el-carousel-item v-for="(item, index) in huaiImgBox" :key="index">
				<img ref="bannerHeight" @load="imgLoad" class="carouselImg" :src="item.img" alt="">
			</el-carousel-item>
		</el-carousel>

		<el-carousel v-if="this.brandId == 2" class="carouselMainBox" :height="bannerHeight + 'px'" :interval="5000"
			arrow="always" autoplay indicator-position="none">
			<el-carousel-item v-for="(item, index) in xinImgBox" :key="index">
				<img ref="bannerHeight" @load="imgLoad" class="carouselImg" :src="item.img" alt="">
			</el-carousel-item>
		</el-carousel>



		<el-carousel v-if="this.brandId == 4" class="carouselMainBox" :height="bannerHeight + 'px'" :interval="5000"
			arrow="always" autoplay indicator-position="none">
			<el-carousel-item v-for="(item, index) in shuiImgBox" :key="index">
				<img ref="bannerHeight" @load="imgLoad" class="carouselImg" :src="item.img" alt="">
			</el-carousel-item>
		</el-carousel>

		<el-carousel v-if="this.brandId == 3" class="carouselMainBox" :height="bannerHeight + 'px'" :interval="5000"
			arrow="always" autoplay indicator-position="none">
			<el-carousel-item v-for="(item, index) in yiImgtaoheBox" :key="index">
				<img ref="bannerHeight" @load="imgLoad" class="carouselImg" :src="item.img" alt="">
			</el-carousel-item>
		</el-carousel>

		<el-carousel v-if="this.brandId == 5" class="carouselMainBox" :height="bannerHeight + 'px'" :interval="5000"
			arrow="always" autoplay indicator-position="none">
			<el-carousel-item v-for="(item, index) in zhongImgBox" :key="index">
				<img ref="bannerHeight" @load="imgLoad" class="carouselImg" :src="item.img" alt="">
			</el-carousel-item>
		</el-carousel>



		<div class="productsMain">
			<div class="productsMainTabs">
				<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
					<el-tab-pane v-for="(item, index) in seriesData" :key="index" :label="item.series_name"
						:name="'item' + index">
						<div class="firstBox">
							<div class="productsItemBox" v-for="(itemShopping, index) in productsData" :key="index">
								<div class="productsImgBox">
									<img class="productsImg" :src="itemShopping.thumbnail_url" alt="" :title="itemShopping.title+'￥'+ itemShopping.prize+'/'+itemShopping.description">
								</div>
								<div class="productsLine"></div>
								<div class="productsTitle">{{ itemShopping.title }}</div>
								<div class="productsTitleBox" style="flex-direction: row">
									<div class="productsPrice" style="width: 40%">￥{{ itemShopping.prize }} </div>
									<div class="productsPrice1">{{ itemShopping.description }} </div>
								</div>


								<!-- <div class="bosAnd">
									   <img class="bosAndImg"  src="../assets/goodsShop.png" alt="">
									</div> -->
							</div>

							<div class="paginationBox">
								<!-- 分页 -->
								<zpagenav v-bind:page="pageNum" v-bind:page-size="pageSize" v-bind:total="total"
									v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
								</zpagenav>
							</div>
						</div>

					</el-tab-pane>
				</el-tabs>

			</div>



			<!-- 底部 -->
			<div class="footerOuter">
				<div class="footerBox">

					<div class="footerBoxHeader">
						<div class="footerBoxHeaderLeft">
							<img class="codeImg" src="../assets/code.png" alt="">
							<span class="codeText">兰树公众号</span>
						</div>
						<div class="footerBoxHeaderRight">
							<img class="codeImg" src="../assets/xcxNew.jpg" alt="">
							<span class="codeText">兰树云小程序</span>
						</div>
						<!-- <div class="footerBoxHeaderRight">
									<img class="codeImg" src="../assets/code.png" alt="">
									<span class="codeText">兰树客服(QQ)</span>
								</div> -->

					</div>
					<div class="footerMainBox">
						<li class="footerShop"><a target="_blank"
								href="https://huaishu.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.124378dduXIhiW">淮树旗舰店</a>
						</li>
						<li class="footerShop"><a target="_blank"
								href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">心清堂官方企业店</a>
						</li>
						<li class="footerShop"><a target="_blank" href="https://shop349169226.taobao.com/?spm=a21xtw.29978516.0.0">水姻缘旗舰店</a></li>
						<li class="footerShop"><a target="_blank"
								href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">一清堂官方企业店</a>
						</li>
						<li class="footerShop"><a target="_blank" href="https://drchung.tmall.com" ><span>Dr.CHUNG</span>旗舰店</a></li>
						<li class="footerShop"><a target="_blank" href="https://zhibenqingfang.tmall.com">植本清方旗舰店</a></li>
						<div class="lastHeader">
							<li><router-link to="/login" tag="a">登录</router-link></li>
							|
							<li><router-link to="/login" tag="a">注册</router-link></li>
						</div>
					</div>

					<div class="footerInfoBox">
						<div class="emailBox">邮箱: postermaster@lasur.com</div>
						<div class="phoneBox">电话: 0571-89025888</div>
						<div class="addressBox">地址: 浙江省杭州市之江东路越秀·维多利中心A座 17楼</div>
					</div>



					<div class="footerLine"></div>
					<div class="footerBoxBottom">
						<div class="footerLeft">
							Copyright © 2023 兰树化妆品股份有限公司 <a target="_blank"
								href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a> |
							<img height="16px" src="../assets/plice.png" />&nbsp;<a target="_blank"
								href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
								33052102000740号</a>
						</div>
					</div>

				</div>
			</div>


		</div>



	</div>
</template>

<script>
import { myGet, myPost, login } from "@/api/http";
export default {
	data() {
		return {
			//动态设置 轮播的高度
			bannerHeight: '',
			pageNum: 1,  //显示的是哪一页
			pageSize: 12, //每一页显示的数据条数
			total: 10, //记录总数
			maxPage: 12,  //最大页数
			activeName: 'item0',
			shoppingId: '',
			productsData: [
			],
			brandId: '',
			imgLength: '',
			seriesid: '',
			seriesData: [],
			huaiImgBox: [
				{
					id: 1,
					img: require('../assets/LunBo/huaiLun.jpg')
				}
			],
			xinImgBox: [
				{
					id: 1,
					img: require('../assets/LunBo/xinLun.jpg')
				}
			],
			shuiImgBox: [
				{
					id: 1,
					img: require('../assets/LunBo/shuiLun.jpg')
				}
			],
			yiImgBox: [
				{
					id: 1,
					img: require('../assets/LunBo/yiLun.jpg')
				}
			],
			yiImgtaoheBox: [
				{
					id: 1,
					img: 'https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-16_16-11-01_92629.png'
				}
			],
			zhongImgBox: [
				{
					id: 1,
					img: require('../assets/LunBo/zhongLun.jpg')
				}
			],

			brandItem: [
				{
					id: 1,
					chooseId: 0,
					imgBox: [
						{
							id: 1,
							img: require('../assets/LunBo/huaiLun.jpg')
						},
						{
							id: 2,
							img: require('../assets/LunBo/shuiLun.jpg')
						},
						{
							id: 3,
							img: require('../assets/LunBo/yiLun.jpg')
						},
						{
							id: 4,
							img: require('../assets/LunBo/zhongLun.jpg')
						}
					]
				},
				{
					id: 2,
					chooseId: 1,
					imgBox: [
						{
							id: 1,
							img: require('../assets/LunBo/xinLun.jpg')
						}

					]
				},
				{
					id: 3,
					chooseId: 2,
					imgBox: [
						{
							id: 1,
							img: require('../assets/LunBo/shuiLun.jpg')
						}
						// {
						// 	id:2,
						// 	img:require('../assets/LunBo/shuiLun.jpg')
						// },
						// {
						// 	id:3,
						// 	img:require('../assets/LunBo/yiLun.jpg')
						// }
					]
				},
				{
					id: 4,
					chooseId: 3,
					imgBox: [
						{
							id: 1,
							img: require('../assets/LunBo/yiLun.jpg')
						}
						// {
						// 	id:2,
						// 	img:require('../assets/LunBo/shuiLun.jpg')
						// },
						// {
						// 	id:3,
						// 	img:require('../assets/LunBo/zhongLun.jpg')
						// }
					]
				},
				{
					id: 5,
					chooseId: 4,
					imgBox: [
						{
							id: 1,
							img: require('../assets/LunBo/zhongLun.jpg')
						}
						// {
						// 	id:2,
						// 	img:require('../assets/LunBo/shuiLun.jpg')
						// },
						// {
						// 	id:3,
						// 	img:require('../assets/LunBo/zhongLun.jpg')
						// }
					]
				}
			]

		}
	},
	created() {
		this.getSeries();
		this.brandId = this.$route.query.brandId;
	},
	mounted() {
		console.log('start', this.brandId);
		this.imgLoad();
		window.addEventListener('resize', () => {
			this.bannerHeight = this.$refs.bannerHeight[0].height;
			this.imgLoad();
		}, false)
		// if(this.brandId == 1){
		// 	this.imgLoad();
		// 	window.addEventListener('resize',()=>{
		// 		this.bannerHeight = this.$refs.bannerHeight[0].height;
		// 		this.imgLoad();
		// 	},false)
		// }else if(this.brandId == 2){
		// 	this.imgLoad();
		// 	window.addEventListener('resize',()=>{
		// 		this.bannerHeight = this.$refs.bannerHeight[0].height;
		// 		this.imgLoad();
		// 	},false)
		// }else if(this.brandId == 3){
		// 	this.imgLoad();
		// 	window.addEventListener('resize',()=>{
		// 		this.bannerHeight = this.$refs.bannerHeight[0].height;
		// 		this.imgLoad();
		// 	},false)
		// }else if(this.brandId == 4){
		// 	this.imgLoad();
		// 	window.addEventListener('resize',()=>{
		// 		this.bannerHeight = this.$refs.bannerHeight[0].height;
		// 		this.imgLoad();
		// 	},false)
		// }else if(this.brandId == 5){
		// 	this.imgLoad();
		// 	window.addEventListener('resize',()=>{
		// 		this.bannerHeight = this.$refs.bannerHeight[0].height;
		// 		this.imgLoad();
		// 	},false)
		// }

	},
	methods: {
		imgLoad() {
			console.log('brandId', this.brandId);
			this.$nextTick(() => {
				this.bannerHeight = this.$refs.bannerHeight[0].height;
				console.log(this.$refs.bannerHeight[0].height);
			})

		},
		handleClick(tab, event) {
			let that = this;
			console.log(tab, event);
			console.log("www", tab.$el.id);
			let selId = tab.$el.id;
			for (let i = 0; i < that.seriesData.length; i++) {
				if (selId == 'pane-item' + i) {
					this.pageNum = 1;
					that.shoppingId = that.seriesData[i].id;
					that.getShopping(that.shoppingId);
				}
			}


		},
		//点击获取商品信息
		getShopping(opction) {
			console.log("opction", opction)
			this.seriesid = opction;
			myPost("api/goodslist/", {
				id: this.seriesid,
				pageNum: this.pageNum,
				pageSize: 12
			}).then((res) => {
				this.productsData = res.data.videolist;
				this.total = res.data.total_num;
			})

		},
		//获取品牌系列
		getSeries() {
			let id = this.$route.query.brandId
			let that = this;
			myPost("api/serieslist/", {
				id: id,
				// pageNum: this.pageNum,
				// pageSize:6,
			}).then((res) => {


				this.seriesData = res.data.videolist;

				console.log("品牌系列", this.seriesData);
				this.getSeriesProducts(this.seriesData[0].id);
				this.total = res.data.total_num;

			})
		},

		//获取系列商品
		getSeriesProducts(opaction) {

			console.log("1234", opaction);
			let seriesId = opaction;
			this.seriesid = seriesId;
			myPost("api/goodslist/", {
				id: seriesId,
				pageNum: this.pageNum,
				pageSize: 12
			}).then((res) => {
				this.productsData = res.data.videolist;
				this.total = res.data.total_num;

			})
		},

		pageHandler: function (page) {
			console.log(1);
			this.pageNum = page;
			myPost("api/goodslist/", {
				id: this.seriesid,
				pageNum: page,
				pageSize: 12
			}).then((res) => {
				this.productsData = res.data.videolist;
				this.total = res.data.total_num;
			});

		},
		enterHome() {
			this.$router.push({ path: '/' });
		},


	},



}
</script>

<style scoped>
.huaishuContainer {
	display: flex;
	flex-direction: column;
}


/* 导航 */
.navBar {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	position: absolute;
	justify-content: space-between;
	top: 0;
	background: #FFFFFF;
	/* border-bottom:1px solid rgba(255,255,255,0.2); */
	z-index: 999;
}

.carouselImg {
	width: 100%;
}

.carouselMainBox {
	margin-top: 3rem;
}

.router-link-active {
	background-color: #0F3F93 !important;
	color: #FFFFFF !important;
}


.navLogo {
	width: 10%;
	margin-left: 5em;
	cursor: pointer;
}

.navBarItem {
	display: flex;
	flex-direction: row;
	align-items: center;
	/* justify-content: flex-end; */
	/* margin-left: 2em; */
	/* margin-right: 5em; */
}

.navBarItem li {
	/* list-style: none;
		padding: 1.5em 2.5em 1.5em 2.5em;
		float: left; */
	list-style: none;
	/* padding: 25px 40px 25px 40px; */
	float: left;
	/* margin-left: 2em; */
}

.navBarItem li a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #222222;
	line-height: 20px;
	padding-top: 1.3em;
	padding-bottom: 1.3em;
	padding-left: 2em;
	padding-right: 2em;
}


/* .elDropdown{
		margin-left: -5em;
		margin-top: -1em;
	} */

.elDropdown a {
	color: #111111;
	text-decoration: none;
}

.el-dropdown {
	vertical-align: top;
}

.el-dropdown+.el-dropdown {
	margin-left: 15px;
}

.el-icon-arrow-down {
	font-size: 12px;
}

.el-dropdown-link {
	cursor: pointer;
}

.el-icon-arrow-down {
	font-size: 12px;
}


.productsBd {
	width: 100%;
	margin-top: 3rem;
	/*  display: flex;
		  align-items: center; */
}


.productsMain {
	display: flex;
	flex-direction: column;
	width: 100%;
	background: #F6F6F6;
	/* position:absolute; */
	/* top:35em; */
}

.productsMainTabs {
	display: flex;
	flex-direction: column;
	width: 80%;
	margin: 0 auto;
	position: relative;
	margin-top: 1em;
	background: #F6F6F6;
	padding-bottom: 2em;
}

.firstBox {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	/* justify-content: space-around; */
	width: 90%;
	margin: 0 auto;
	padding-bottom: 5em;
	background: #F6F6F6;
}


.productsItemBox {
	width: 10vw;
	display: flex;
	flex-direction: column;
	cursor: pointer;
	align-items: center;
	justify-content: center;
	transition: 0.3s ease;
	padding-bottom: 2em;
	margin-top: 2em;
	background-color: #FFFFFF;
	margin-left: 5%;
	overflow: hidden;
	border-radius: 6px;
	/* position: relative; */
}

.productsTitleBox {
	width: 100%;
	display: flex;
	flex-direction: row;
	cursor: pointer;
	align-items: center;
	justify-content: center;
	transition: 0.3s ease;
	margin-top: 2em;
	background-color: #FFFFFF;
	/* margin-left: 20%;
	margin-right: 20%; */
	/* margin-left: 20%; */
	/* overflow: hidden;
		  border-radius: 6px; */
	/* position: relative; */
}


.productsItemBox:hover .productsImg {
	transform: scale(1.05);
	transition: 0.6s ease;
}

.productsImg {
	width: 100%;
	object-fit: cover;
	transition: 0.6s ease;
}


.productsImgBox {
	width: 100%;
	height: 10vw;
	margin: 0 auto;
	overflow: hidden;
}

.productsTitleBox {
	width: 100%;
	flex-direction: row;
	font-size: 0.9375em;
	font-family: Helvetica;
	color: #1C1C1C;
	line-height: 22px;
	margin-top: 0.5em;
}

.productsTitle {
	width: 80%;
	font-size: 0.9375em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #545454;
	line-height: 22px;
	margin-top: 1em;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	/* padding-bottom: 10px; */
}


.productsLine {
	width: 100%;
	height: 1px;
	background: #E4E4E4;
}

.productsPrice {
	width: 70%;
	font-size: 0.9375em;
	flex-direction: row;
	font-family: Helvetica;
	color: #1C1C1C;
	line-height: 22px;
	margin-top: 0.5em;
margin-left: 10%;

}

.productsPrice1 {
	width: 70%;
	font-size: 0.9375em;
	flex-direction: row;
	font-family: Helvetica;
	color: #1C1C1C;
	line-height: 22px;
	margin-top: 0.5em;
margin-left: 10%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}


/* 分页 */
.pagination {
	margin: 0 auto;
	position: absolute;
	bottom: 0;
}

/* .fenye{
		  display: flex;
		  justify-content: center;
	  }
	  */
/* footer */
.footerBox {
	width: 90%;
	/* height: 287px; */
	background: #F8F9FB;
	/* position:absolute;
	   		bottom:0; */
	margin: 0 auto;
	flex-direction: column;
	z-index: 999;
	margin-top: 1rem;
}


.footerOuter {
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #F8F9FB;
}

.footerBoxHeader {
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-top: 2%;
}


.footerBoxHeaderLeft {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.footerBoxHeaderCenter {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 5em;
}

.footerBoxHeaderRight {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: 5em;
}

.footerBoxHeaderMiddle {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.codeImg {
	width: 100%;
}

.codeText {
	font-size: 0.88em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 20px;
	/* margin-top: 0em; */
}



.footerLine {
	width: 79%;
	height: 1px;
	display: flex;
	background: #000000;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 1em;
}



.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2rem;
}

.emailBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
}


.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 1rem;
}



.footerLeft {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 24px;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #666666;
}

.footerLeft a:hover {
	color: #003F98;
}

.footerMiddle {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.footerMiddle span {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 24px;
}

.footerRight {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.footerRight li a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 28px;
}

.footerRight li {
	list-style: none;
}

.footerLast {
	display: flex;
	flex-direction: column;
	margin-left: 1em;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
	line-height: 28px;
	margin-left: 2em;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.875rm;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerLast span {
	font-size: 0.875em;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #666666;
}

.footerMainBox {
	display: flex;
	flex-direction: row;
	margin: 0 auto;
	align-items: center;
	flex-direction: row;
	justify-content: center;
	margin-top: 2em;
}



.footerShop {
	list-style: none;
	position: relative;
}

.footerShop span{
	margin-right: 10px;
}
.footerShop span::after{
	content: '+';
	display:block;
	position: absolute;
	top: -6px;
	right: 43px;
}

.footerShop a {
	text-decoration: none;
	font-size: 0.875rem;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	padding-left: 2em;
	line-height: 28px;
}


.bosAnd {
	width: 100%;
	display: flex;
	text-align: left;
}


.bosAndImg {
	width: 10%;
	margin-left: 1.5rem;
	margin-top: 1rem;
}


.paginationBox {
	width: 100%;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
}

/* 轮播 */
.el-carousel__item h3 {
	color: #475669;
	font-size: 14px;
	opacity: 0.75;
	line-height: 200px;
	margin: 0;
}

.el-carousel__item:nth-child(2n) {
	background-color: #F6F6F6;
}

.el-carousel__item:nth-child(2n+1) {
	background-color: #F6F6F6;
}

.block {
	display: block;
}

.none {
	display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductsList.vue